import React, { useState } from 'react'
import PropTypes from 'prop-types'
import { Modal, Tag, Tooltip } from 'antd'
import { PlusOutlined } from '@ant-design/icons'
import { useTranslation } from 'react-i18next'
import styled from 'styled-components'

import OrderStaffForm from './Form'

const ROLE_COLORS = {
  cs: '#fa8c16',
  sale: '#13c2c2',
  purchaser: '#c41d7f',
  logistic: '#1e4eeb',
  online: '#e73c2f',
}

const PillsWrapper = styled.span`
  display: inline-flex;
  flex-wrap: wrap;
  gap: 4px 6px;
  align-items: center;

  .staff-pill {
    margin: 0;
    padding: 2px 10px;
    border-radius: 12px;
    font-size: 12px;
    line-height: 1.4;
    color: #fff;
    border: none;
    cursor: ${({ $editable }) => ($editable ? 'pointer' : 'default')};
  }

  .staff-pill.empty {
    color: #8c8c8c;
    background: #f5f5f5;
  }

  .staff-pill.add {
    color: #595959;
    background: #fafafa;
    border: 1px dashed #d9d9d9;
  }

  .staff-role {
    opacity: 0.8;
    margin-left: 4px;
    font-size: 11px;
  }
`

const StaffPillsRender = ({ editable, order, onSaveSuccess, selfAssignSaving }) => {
  const { i18n } = useTranslation()
  const [currentEditMemberId, setCurrentEditMemberId] = useState(null)
  const [activeStaff, setActiveStaff] = useState({})
  const [showFormModal, setShowFormModal] = useState(false)

  const toggleFormModal = (data = {}) => {
    setActiveStaff(data)
    setShowFormModal((v) => !v)
  }

  const handlePillClick = (staff) => {
    if (!editable) return
    setCurrentEditMemberId(staff.orderMemberId)
    toggleFormModal(staff)
  }

  const handleAdd = () => {
    setCurrentEditMemberId(null)
    toggleFormModal({})
  }

  const onCloseModal = () => {
    toggleFormModal()
    setCurrentEditMemberId(null)
  }

  const handleSaveSuccess = (number) => {
    onSaveSuccess(number)
    toggleFormModal()
    setCurrentEditMemberId(null)
  }

  const currentEditMember = order.orderMembers.find(
    (m) => m && m.orderMemberId === currentEditMemberId
  )

  return (
    <>
      <PillsWrapper $editable={editable}>
        {order.orderMembers.map((staff, idx) => {
          if (!staff) {
            return (
              <Tag key={`empty-${idx}`} className='staff-pill empty'>
                ไม่มี
              </Tag>
            )
          }

          const bg = ROLE_COLORS[staff.role] || '#595959'
          return (
            <Tooltip key={staff.orderMemberId || idx} title={`${staff.fullName} (${staff.role})`}>
              <Tag
                className='staff-pill'
                style={{ background: bg }}
                onClick={() => handlePillClick(staff)}
              >
                {staff.firstName}
                <span className='staff-role'>· {staff.role}</span>
              </Tag>
            </Tooltip>
          )
        })}

        {editable && (
          <Tag className='staff-pill add' onClick={handleAdd}>
            <PlusOutlined /> {i18n.t('shared:add')}
          </Tag>
        )}
      </PillsWrapper>

      <Modal
        centered
        footer={null}
        onCancel={onCloseModal}
        open={showFormModal}
        destroyOnClose
      >
        <OrderStaffForm
          currentEditMember={currentEditMember}
          currentEditMemberId={currentEditMemberId}
          onClose={onCloseModal}
          onSaveSuccess={handleSaveSuccess}
          orderId={order.number}
          staffData={activeStaff}
          selfAssignSaving={selfAssignSaving}
        />
      </Modal>
    </>
  )
}

StaffPillsRender.propTypes = {
  editable: PropTypes.bool.isRequired,
  order: PropTypes.object.isRequired,
  onSaveSuccess: PropTypes.func.isRequired,
}

export default StaffPillsRender
